import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Icon, Icons } from '@cld/icon';

export const HEADER_ICON_WIDTH = '30';
export const HEADER_ICON_HEIGHT = '30';

const Circle = styled.div`
  width: ${HEADER_ICON_WIDTH}px;
  height: ${HEADER_ICON_HEIGHT}px;
  background-color: ${globalTheme.palette.secondary};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ColoredIcon = styled(Icon)`
  color: ${globalTheme.palette.contrastLow};
`;

export interface HeaderIconProps {
  iconName: Icons,
}

export const HeaderIcon: FC<HeaderIconProps> = ({ iconName }) => (
  <Circle>
    <ColoredIcon name={iconName} size="md" />
  </Circle>
);
